import { NavLink } from 'react-router-dom'
import styles from './Sidebar.module.css'
import { CiViewBoard, CiSettings } from 'react-icons/ci'
import useAuth from '../hooks/useAuth.ts'

function Sidebar() {
  const { roles } = useAuth()

  const navLinkCssClasses = ({ isActive }: { isActive: boolean }): string => {
    return `${isActive ? styles.active : styles.notActive}`
  }

  return (
    <div className={styles.sidebar}>
      <ul className={styles.sidebarList}>
        <NavLink to={'/pad-data'} className={navLinkCssClasses}>
          <li className={styles.row}>
            <CiViewBoard className={styles.icon} style={{ width: '21px', height: '21px' }} />
            <div className={styles.title}>Data</div>
          </li>
        </NavLink>
        {roles?.includes('Manager') && (
          <NavLink to={'/settings'} className={navLinkCssClasses}>
            <li className={styles.row}>
              <CiSettings className={styles.icon} style={{ width: '21px', height: '21px' }} />
              <div className={styles.title}>Settings</div>
            </li>
          </NavLink>
        )}
      </ul>
    </div>
  )
}

export default Sidebar
